// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2Ryco","selects":"Documents_selects__TVDix"};